import { useContext } from 'react';
import { useQuery, gql } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

// `mode` here is the track the upsell is priced against. It must come from
// THIS table: blendxapi's create_payment_intent reads course_enrollments.mode
// (GET_USER_COURSE_ENROLLMENTS in graphql_helper/queries/user_queries.py) to
// work out the upgrade delta. edx's own student_courseenrollment.mode is a
// different row that can drift, and pricing off it would quote a number the
// gateway does not charge.
const IS_ENROLLED_IN_COURSE = gql`
  query IsEnrolledInCourse($userId: Int4!, $openedxCourseId: Text!) {
    courseEnrollments(
      where: {
        userId: { _eq: $userId }
        course: { openedxCourseId: { _eq: $openedxCourseId } }
      }
      limit: 1
    ) {
      id
      mode
    }
  }
`;

export const useIsEnrolledInCourse = (openedxCourseId) => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading } = useQuery(IS_ENROLLED_IN_COURSE, {
    variables: { userId, openedxCourseId },
    skip: !userId || !openedxCourseId,
  });

  const enrollment = data?.courseEnrollments?.[0] || null;

  return {
    isEnrolled: Boolean(enrollment),
    enrolledMode: enrollment?.mode || null,
    loading,
  };
};
